const AppRoutes = {
  login: '/',
  landing: '/switch-modules',
  home: '/home',
  users: '/users',
  adduser: '/users/add-customer-user',
  editUser: '/edit-user/:id',
  userProfile: '/user/:id',
  notAuthorized: '/autherror',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password/:token',
  firstTimePassword: '/first-time-password',
  usersBatchActionsStatus: '/users/batch-actions-status',
  actionStatusDetails: '/users/status-details/:id',
  NotificationInbox: '/notifications/inbox',
  notificationCenter: '/notifications/center',
  ActionHistory: '/notifications/action-history',
  notification: '/notification',
  accessDenied: '/access-denied',
}

export default AppRoutes
